import { gql } from '@apollo/client'

export const getStreaks = gql`
  query GetStreaks {
    getStreaks
  }
`
